export default __webpack_public_path__ + "static/media/section_bg-seasonality.png";